<template>
  <div class="content">
    <div id="md-hddb"></div>
    <!-- 顶部下载 -->
    <top-download @layout-change="handleTopDownloadLayout"></top-download>
    <!-- 顶部导航栏 -->
    <top-nav
      ref="topNav"
      v-if="isTopNavVisible"
      :key="timer"
      :top-offset="topDownloadHeight"
      @getLoging="getLoging"
    ></top-nav>

    <!-- 固定头部占位元素 -->
    <div
      v-if="topNavPlaceholderHeight"
      :style="{ height: `${topNavPlaceholderHeight}px` }"
    ></div>

    <!-- 公告栏 -->
    <div v-if="$route.path.includes('/home')" class="otag-gg" @click="showNoticePopup = true">
      <van-notice-bar class="notice-bar-style">
        <template #left-icon>
          <img
            src="../../assets/img/common/com-lb.png"
            style="width: 15px"
            class="m-r-10 notice-bar-icon"
          />
        </template>
        <div class="d-flex notice-bar-text">
          {{ $lang.common_txt357 }}
        </div>
      </van-notice-bar>
    </div>

    <!-- 公告详情弹窗 -->
    <van-popup v-model="showNoticePopup" round :close-on-click-overlay="true" class="notice-popup">
      <div class="notice-popup__content">
        <div class="notice-popup__header">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#24ee89"><path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>
          <span>{{ $lang.notice_title || 'Notice' }}</span>
          <van-icon name="cross" size="18" color="#94a3b8" @click="showNoticePopup = false" />
        </div>
        <div class="notice-popup__body">
          {{ $lang.common_txt357 }}
        </div>
      </div>
    </van-popup>

    <div
      v-if="$route.path.includes('/home') && bannerList.length"
      class="content-swiper-bg"
      style="margin-top: 10px"
    >
      <van-swipe
        ref="bannerSwipe"
        :autoplay="3500"
        class="swipe-fixed-height"
        :show-indicators="false"
        @change="onBannerChange"
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          @click="onBannerClick(item)"
        >
          <img class="content-swiper--img" :src="item.advertisementImg" />
        </van-swipe-item>
      </van-swipe>
      <!-- 左右箭头按钮 -->
      <div class="banner-arrow-wrap">
        <div class="banner-arrow banner-arrow-left" @click="bannerPrev">
          <van-icon name="arrow-left" size="16" color="#ffffff" />
        </div>
        <div class="banner-arrow banner-arrow-right" @click="bannerNext">
          <van-icon name="arrow" size="16" color="#ffffff" />
        </div>
      </div>
      <!-- Banner 指示器 -->
      <div class="banner-indicators">
        <span
          v-for="(item, index) in bannerList.length"
          :key="index"
          class="banner-dot"
          :class="{ active: currentBannerIndex === index }"
        ></span>
      </div>
    </div>
    <!-- 二级路由出口 -->
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view> </router-view>
    </keep-alive>
    <router-view v-else></router-view>

    <!-- 底部导航栏 -->
    <van-tabbar
      v-if="
        !$route.path.includes('/Country') &&
        !$route.path.includes('/Crowdfunding') &&
        !$route.path.includes('/appDetail')
      "
      v-model="active"
      class="custom-tabbar"
      :border="false"
    >
      <van-tabbar-item
        v-for="(item, index) in tabList"
        :key="index"
        @click="handleTabClick(item.to, index)"
      >
        <span>{{ item.title }}</span>
        <template #icon>
          <img :src="active === index ? item.img_a : item.img" />
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <!-- 登录&&注册 -->
    <login v-model="showPopup" overlay @close-key="close"></login>
    <!-- 大转盘 -->
    <!-- <lucky-roulette
      v-model="isShowPopup"
      @login-key="LoginKey"
      overlay
    ></lucky-roulette> -->
    <!-- <div v-if="!['/Country'].includes($route.path)" class="fj-cont">
      <div v-if="isFjShow" class="d-flex">
        <img
          class="fj-cont-i"
          @click="goTofj(1)"
          src="../../assets/img/common/img_tg.png"
          width="50"
        />
      </div>
    </div> -->
    <!-- <van-popup
      v-if="['/lottery', '/home'].includes($route.path)"
      v-model="showDialog"
      class="custom-popup2"
      :closeable="false"
      :close-on-click-overlay="false"
    >
      <div v-if="isff2" class="cont-redim"></div>

      <div v-if="isff" class="cont-redim2"></div>

      <div v-if="isff2" class="d-flex-s m-t-10">
        <div class="d-flex">
          <van-checkbox
            v-model="agree"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: 11px">{{ $lang.home_txt7 }}</p>
        </div>
        <div class="d-flex">
          <van-checkbox
            v-model="agree2"
            shape="square"
            icon-size="16px"
            icon-color="#202A39"
            style="
              border: 1px solid #6f7887;
              margin-right: 3px;
              border-radius: 5px;
            "
          ></van-checkbox>
          <p style="color: #ffffff; font-size: 11px">{{ $lang.home_txt8 }}</p>
        </div>
      </div>
      <img
        class="m-t-10"
        @click="closeF()"
        src="../../assets/img/lucky_jackpot/img_cancel.png"
        width="38"
      />
    </van-popup> -->
    <!-- 活动 -->
    <activity-popup
      v-if="$route.path.includes('/lottery') || $route.path.includes('/home')"
      v-model="isShowPopup2"
      @closeActive="closeActive"
      @closeActive2="closeActive2"
    ></activity-popup>
  </div>
</template>

<script>
import TopDownload from '../../components/TopDownload.vue' //顶部下载
import TopNav from '../../components/TopNav.vue' //顶部导航栏
import {
  Init,
  VnRechargeInitS,
  GameBalanceList,
  WithdrawInit,
  ActivitygetRegisterAward,
  GetInvitationID,
  GetBannerList
} from '@/api/common'
import { consumeOpenLoginAfterPlatformSwitch } from '@/utils/platformAuth'
export default {
  components: {
    TopDownload,
    TopNav
  },
  name: 'index',
  computed: {
    isTopNavVisible() {
      return this.$route.path.includes('/home') || this.$route.path.includes('/menu')
    },
    topNavPlaceholderHeight() {
      return this.topDownloadHeight + (this.isTopNavVisible ? 60 : 0)
    },
    // 获取当前路由前缀，确保 tabbar 路径正确匹配
    routePrefix() {
      return this.$route.params.prefix || localStorage.getItem('country') || ''
    },
    // 底部导航列表
    tabList() {
      const prefix = this.routePrefix
      return [
        {
          title: this.$lang.tab_menu,
          to: '/' + prefix + '/menu',
          img: require('@/assets/img/menu_grid_original.svg'),
          img_a: require('@/assets/img/menu_grid_click.svg')
        },
        {
          title: this.$lang.tab_promotions || this.$lang.Bônus,
          to: '/' + prefix + '/activity',
          img: require('@/assets/img/menu_wallet_click.png'),
          img_a: require('@/assets/img/menu_wallet_original.png')
        },
        {
          title: this.$lang.Início,
          to: '/' + prefix + '/home',
          img: require('@/assets/img/menu_agent_original.png'),
          img_a: require('@/assets/img/menu_agent_click.png')
        },
        {
          title: this.$lang.Depósito,
          to: '/' + prefix + '/rechargeCont',
          img: require('@/assets/img/depist.png'),
          img_a: require('@/assets/img/depist2.png')
        },
        {
          title: this.$lang.Meu,
          to: '/' + prefix + '/mine',
          img: require('@/assets/img/menu_personal_original.png'),
          img_a: require('@/assets/img/menu_personal_click.png')
        }
      ]
    }
  },
  data() {
    return {
      active: 0,
      // images2: [
      //   `https://file.otgame.bet/static/${this.getCurrency}/1.png`
      // ],
      images: [
        require('@/assets/img/lottery/lottba1.png'),
        require('@/assets/img/lottery/lottba2.png'),
        require('@/assets/img/lottery/lottba3.png'),
        require('@/assets/img/lottery/lottba4.png')
      ],
      agree2: false,
      agree: false,
      MenList: [
        {
          img: require('@/assets/img/home/men_1.png'),
          name: this.$lang.common_txt138
        },
        {
          img: require('@/assets/img/home/men_2.png'),
          name: this.$lang.common_txt139
        }
      ],
      isFjShow: true,
      isFjShow2: true,
      showDialog: false,
      isShowPopup: false,
      isShowPopup2: false,
      timer: null,
      topDownloadHeight: 0,
      showPopup: false, //登录弹窗开关
      // tabBar: [
      //   {
      //     title: this.$lang.Início,
      //     to: '/home',
      //     img: require('@/assets/img/menu_home_original.png'),
      //     img_a: require('@/assets/img/menu_home_click.png')
      //   },
      //   {
      //     title: this.$lang.Depósito,
      //     to: '/rechargeCont',
      //     img: require('@/assets/img/menu_wallet_original.png'),
      //     img_a: require('@/assets/img/menu_wallet_click.png')
      //   },
      //   {
      //     title: this.$lang.common_txt26,
      //     to: '/Crowdfunding',
      //     img: require('@/assets/img/menu_agent_original.png'),
      //     img_a: require('@/assets/img/menu_agent_click.png')
      //   },
      //   {
      //     title: this.$lang.common_txt23,
      //     to: '/Support',
      //     img: require('@/assets/img/menu_activity_original.png'),
      //     img_a: require('@/assets/img/menu_activity_click.png')
      //   },

      //   {
      //     title: this.$lang.Meu,
      //     to: '/mine',
      //     img: require('@/assets/img/menu_personal_original.png'),
      //     img_a: require('@/assets/img/menu_personal_click.png')
      //   }
      // ],
      // selectMenIndex: this.$route.path === '/home' ? 1 : 0
      selectMenIndex: 0,
      isff: true,
      isff2: false,
      currentBannerIndex: 0,
      bannerList: [],
      showNoticePopup: false
    }
  },
  watch: {
    // 监听路由变化，同步 tab 高亮
    $route: {
      handler(to) {
        const path = to.path
        if (path.includes('/menu')) {
          this.active = 0
        } else if (path.includes('/activity') || path.includes('/bonus')) {
          this.active = 1
        } else if (path.includes('/home')) {
          this.active = 2
        } else if (path.includes('/rechargeCont')) {
          this.active = 3
        } else if (path.includes('/mine')) {
          this.active = 4
        }

        if (to.query.isValue === 'isLogin') {
          this.showPopup = true
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })
    // 页面加载时判断是否需要显示弹窗
    this.checkPopupStatus()
    // this.ActivitygetRegisterAward()
    const today = new Date().toISOString().split('T')[0]

    if (sessionStorage.getItem('neverShowToday2') === today) {
      this.showDialog = false
    } else if (localStorage.getItem('neverShow2')) {
      // 检查永久不显示
      this.showDialog = false
    } else {
      this.showDialog = true
    }

    // 全局监听登录弹窗事件（未登录接口、活动页等场景统一触发）
    this.$bus.$on('openLogin', this.handleOpenLogin)
    this.$nextTick(() => {
      if (consumeOpenLoginAfterPlatformSwitch() && this.$bus) {
        this.$bus.$emit('openLogin')
      }
    })
  },
  beforeDestroy() {
    this.$bus.$off('openLogin', this.handleOpenLogin)
  },
  async created() {
    this.fetchBannerList()
    if (this.$route.query.id) {
      await localStorage.setItem('id', this.$route.query.id)
      await GetInvitationID()
    }
    if (!localStorage.getItem('fbExpand')) {
      localStorage.setItem(
        'fbExpand',
        this.$pixel.getUrlFBParams().replace('#/home?', '&')
      )
    }
  },
  methods: {
    handleTopDownloadLayout({ height }) {
      this.topDownloadHeight = height
    },
    handleOpenLogin() {
      this.showPopup = true
    },
    // 处理 tab 点击
    handleTabClick(to, index) {
      this.active = index
      // 需要登录的 tab (第4个: Depósito, 第5个: Meu)
      if (index === 3 || index === 4) {
        this.checkLoginAndProceed(index, to)
        return
      }
      // 跳转路由
      if (this.$route.path !== to) {
        this.$router.push(to)
      }
    },
    // 检查登录状态
    async checkLoginAndProceed(index, to) {
      const data = await Init()
      if (data.status === 'need_login') {
        this.showPopup = true
        return
      }
      if (this.$route.path !== to) {
        this.$router.push(to)
      }
    },
    async GetInvitationID() {
      const data = await GetInvitationID({
        inviteCode: localStorage.getItem('id')
      })
      if (data.status === 'ok') {
        if (data.content.invitCode) {
          localStorage.setItem('id', data.content.invitCode)
        }
      }
    },
    goToDetail3(i) {
      if (i === 0) {
        this.$jumpTo('/Crowdfunding')
      } else if (i === 1) {
        this.$jumpTo('/Alliance')
      } else if (i === 2) {
        this.$jumpTo('/vipSignIn')
      } else if (i === 3) {
        this.$jumpTo('/redPacket')
      } else if (i === 4) {
        this.$jumpTo('/referFriend')
      } else if (i === 5) {
        this.$jumpTo('/cashBack')
      } else if (i === 6) {
        this.$jumpTo('/signIn')
      } else if (i === 7) {
        this.$jumpTo('/activityFistRecharge')
      } else if (i === 8) {
        this.$jumpTo('/Support')
      }
    },
    onBannerChange(index) {
      this.currentBannerIndex = index
    },
    bannerPrev() {
      if (this.currentBannerIndex > 0) {
        this.$refs.bannerSwipe.swipeTo(this.currentBannerIndex - 1)
      } else {
        this.$refs.bannerSwipe.swipeTo(this.bannerList.length - 1)
      }
    },
    bannerNext() {
      if (this.currentBannerIndex < this.bannerList.length - 1) {
        this.$refs.bannerSwipe.swipeTo(this.currentBannerIndex + 1)
      } else {
        this.$refs.bannerSwipe.swipeTo(0)
      }
    },
    async fetchBannerList() {
      try {
        const data = await GetBannerList({})
        if (data.status === 'ok' && data.content && data.content.bannerList) {
          this.bannerList = data.content.bannerList.sort((a, b) => b.ordered - a.ordered)
        }
      } catch (e) {
        console.error('fetchBannerList error', e)
      }
    },
    onBannerClick(item) {
      if (item.extendJson) {
        window.location.href = item.extendJson.startsWith('http') ? item.extendJson : 'https://' + item.extendJson
      }
    },
    closeActive() {
      this.showDialog = false
    },
    closeActive2() {
      this.showDialog = true
    },
    async ActivitygetRegisterAward() {
      const data = await ActivitygetRegisterAward()
      if (data.status === 'ok') {
        if (data.content.receiveStatus === 1) {
          this.isShowPopup2 = true
        } else {
          this.isShowPopup2 = false
        }
      } else if (data.status === 'need_login') {
        this.isShowPopup2 = true
      }
    },
    goToMen(i) {
      this.selectMenIndex = i
      if (i === 0) {
        this.$jumpTo('/lottery')
      } else {
        this.$jumpTo('/home')
      }
    },
    goTofj(i) {
      if (i === 1) {
        window.open('https://t.me/OTgamel')
      }
      // if (i === 1) {
      //   this.$router.push('./activityFistRecharge')
      // } else if (i === 2) {
      //   this.$router.push('./cashBack')
      // }
    },
    closeF2(i) {
      if (i === 1) {
        this.isFjShow = false
      } else if (i === 2) {
        this.isFjShow2 = false
      }
    },
    closeF() {
      if (this.agree) {
        // 今日不显示
        const today = new Date().toISOString().split('T')[0]
        sessionStorage.setItem('neverShowToday2', today)
      }
      if (this.agree2) {
        // 永久不显示
        localStorage.setItem('neverShow2', true)
      }
      if (this.isff2) {
        this.showDialog = false
      }
      this.isff = false
      if (!this.isff) {
        this.isff2 = true
        return
      }
    },
    submit2() {
      localStorage.removeItem('isRegister')
      this.showDialog = false
      // this.$router.push('/recharge')
      this.$jumpTo('/rechargeCont')
    },
    getLoging() {
      this.showPopup = true
    },
    LoginKey() {
      this.showPopup = true
    },
    // 检查是否需要显示弹窗
    checkPopupStatus() {
      const today = this.getTodayString()
      const lastShownDate = localStorage.getItem('popupLastShownDate')
      const isClosedToday = localStorage.getItem('popupClosedToday') === 'true'

      // 如果今天已经显示过或者今天关闭过，则不显示
      if (lastShownDate === today || isClosedToday) {
        this.isShowPopup = false
        // this.isShowPopup2 = false
      } else {
        this.isShowPopup = true
        // this.isShowPopup2 = true

        // 记录今天已经显示过弹窗
        localStorage.setItem('popupLastShownDate', today)
      }
      // if (localStorage.getItem('isRegister') === 'isRegister') {
      //   this.showDialog = true
      // }
    },
    // 打开弹窗
    openPopup() {
      const today = this.getTodayString()
      // 如果今天没有显示过弹窗且没有被关闭过，则可以手动打开
      if (
        !localStorage.getItem('popupLastShownDate') ||
        localStorage.getItem('popupLastShownDate') !== today
      ) {
        this.isShowPopup = true
        // this.isShowPopup2 = true
        localStorage.setItem('popupLastShownDate', today)
      }
    },
    // 关闭弹窗
    closePopup() {
      this.isShowPopup = false
      // 记录今天关闭过弹窗
      localStorage.setItem('popupClosedToday', 'true')
    },
    // 获取当前日期字符串（格式：YYYY-MM-DD）
    getTodayString() {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    close() {},
    async GameBalanceList() {
      const data = await GameBalanceList()
      console.log(data)
    },
    async WithdrawInit() {
      const data = await WithdrawInit()
      console.log(data)
    },
    async VnRechargeInitS() {
      const data = await VnRechargeInitS()
      if (data.status === 'ok') {
        console.log('-')
      }
    },
    // 登录
    async isLogin(i) {
      // 第一个tab点击后由 van-tabbar 的 route 属性自动处理路由跳转和高亮
      if (i === 0) return
      // 1. 通过 id 获取目标元素
      const target = document.getElementById('md-hddb')
      if (!target) return // 防止 id 不存在报错
      target.scrollIntoView({
        behavior: 'auto', // 滚动行为：smooth（平滑）/ auto（瞬间，默认）
        block: 'start', // 对齐方式：start（顶部对齐）/ center（居中）/ end（底部对齐）
        inline: 'nearest' // 水平对齐（默认即可）
      })
      if (i !== 2 && i !== 3) {
        const data = await Init()
        if (data.status === 'need_login') {
          this.showPopup = true
          this.timer++
        }
      }
      // this.$nextTick(() => {
      //   window.scrollTo(0, 0)
      // })
      if (i === 2 && localStorage.getItem('token')) {
        this.GameBalanceList()
        this.WithdrawInit()
      }
      // if (!localStorage.getItem('token')) {
      //   console.error = (message, ...args) => {
      //     if (message.includes('Navigation cancelled')) {
      //       return // 忽略这个特定的错误
      //     }
      //     this.$router.push('/')
      //     console.error(message, ...args)
      //   }
      //   this.timer++
      //   this.showPopup = true
      // }
    }
  }
}
</script>

<style lang="less" scoped>
/* 公告栏 - 图中样式：深色背景、圆角、阴影、白字 */
.otag-gg {
  padding: 0 15px;
  margin-bottom: 4px;
}
::v-deep .van-notice-bar.notice-bar-style {
  background-color: #2c3643 !important;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  padding: 5px 15px;
  color: #ffffff;
  height: 30px;
}
::v-deep .van-notice-bar.notice-bar-style .van-notice-bar__content {
  color: #ffffff;
}
.notice-bar-text {
  color: #ffffff !important;
  font-size: 13px;
}
.notice-bar-icon {
  filter: brightness(1.1);
}

// .con-sw-bg {
//   background: url(../../assets/img/otgame/kuang_05.png) no-repeat;
//   background-size: 100% 100%;
//   height: 195px;
//   width: 96%;
//   margin: 0 auto;
//   left: 0;
//   right: 0;
//   position: absolute;
//   top: -10px;
// }
/* 自定义 van-tabbar 样式 */
/* PC 端样式 */
@media (min-width: 769px) {
  .custom-tabbar {
    width: 450px;
    left: 50%;
    transform: translate(-50%, -50%);
    bottom: -30px;
  }
  .cont-redim {
    height: 477px !important;
    padding-top: 383px !important;
  }
  .cont-redim2 {
    height: 477px !important;
    padding-top: 383px !important;
  }
  .custom-popup2 {
    width: 370px !important;
  }
  ::v-deep .van-sticky--fixed {
    top: 110px !important;
  }
}
::v-deep .van-overlay {
  z-index: 1999 !important;
}
.custom-tabbar {
  z-index: 999;
  height: 60px;
  // background-color: @background-color;
  background: url(../../assets/img/menu_bg.png);
  width: 100%;
  max-width: 450px;
  background-size: 100% 100%;
  border-radius: 13px 13px 0 0;
  // box-shadow: 0 5px 10px rgba(255, 255, 255, 0.9); /* 阴影效果 */
  // ::v-deep > .van-tabbar-item:nth-child(3) {
  // height: 12px;
  // margin-top: 19px;
  // .van-tabbar-item__icon > img {
  //   width: 62px;
  //   height: 60px;
  // margin-top: 58px;
  // border-radius: 50%;
  // border-left: 1px solid #00f; /* 左边蓝色 */
  // border-right: 1px solid #f0f; /* 右边粉色 */
  // }
  // }
  ::v-deep .van-tabbar-item--active img {
    width: 50px;
    height: 25px;
  }
}
::v-deep .van-tabbar-item {
  color: #95a1c1;
  transition: none;
}
::v-deep .van-tabbar-item img {
  // margin-top: 22px;
  width: 50px;
  height: 25px;
  transition: none;
}
::v-deep .van-tabbar-item--active {
  color: #24ee89 !important;
  background-color: transparent;
  border-radius: 13px 13px 0 0;
  animation: none;
  .van-tabbar-item__text {
    position: relative;
  }
}
.custom-popup2 {
  width: 86%;
  text-align: center;
  background-color: transparent; /* 设置背景色 */
  // z-index: 2004 !important;
  .cont-redim {
    // padding-top: 330px;
    background: url(../../assets/img/common/syhd.png) no-repeat;
    background-size: 100% 100%;
    height: 420px;
    border-radius: 15px;
  }
  .cont-redim2 {
    // padding-top: 330px;
    background: url(../../assets/img/common/home_111.png) no-repeat;
    background-size: 100% 100%;
    height: 450px;
    border-radius: 15px;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border: none;
  }
  ::v-deep .van-checkbox__icon--checked .van-icon {
    background-color: #4981f4 !important;
  }
  .van-overlay {
    z-index: 2001 !important;
  }
}
.fj-cont {
  position: fixed;
  bottom: 160px;
  right: 20px;
  text-align: right;
  z-index: 999;
}
.fj-cont-i {
  animation: enlargeAndShake 1.8s ease-in-out infinite;
  transform-origin: bottom; /* 将旋转中心点设置为底部 */
}
@keyframes enlargeAndShake {
  0% {
    transform: scale(1) rotate(0deg);
  }
  20% {
    transform: scale(1.2) rotate(0deg);
  }
  40% {
    transform: scale(1.2) rotate(-10deg); /* 放大并左晃 */
  }
  60% {
    transform: scale(1.2) rotate(10deg); /* 放大并右晃 */
  }
  80% {
    transform: scale(1.2) rotate(-10deg); /* 放大并左晃 */
  }
  100% {
    transform: scale(1.2) rotate(0deg);
  }
}
.select-Men {
  background: #468dff !important;
  color: #ffffff !important;
}
.content-swiper--img {
  width: 94%; /* 图片宽度铺满轮播项 */
  margin: 0 auto;
  height: 182px; /* 图片高度等于轮播容器高度 */
  // object-fit: cover; /* 核心：保持比例裁剪图片，填满容器（避免拉伸变形） */
  display: block; /* 去除图片底部默认空白 */
  border-radius: 10px;
}
.swipe-fixed-height {
  width: 100%; /* 左右铺满父容器（通常是屏幕宽度） */
  /* 清除默认样式干扰 */
  margin: 0;
  padding: 0;
}
.content-swiper-bg {
  position: relative;
  ::v-deep .van-swipe__indicator {
    width: 25px;
    border-radius: 12px;
    color: transparent !important;
  }
  ::v-deep .van-swipe__indicator--active {
    // width: 35px;
    color: #ffffff !important;
  }
  ::v-deep .van-swipe__indicator--active {
    background: #ffffff !important;
  }
}
.banner-arrow-wrap {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  z-index: 10;
  pointer-events: none;
}
.banner-arrow {
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  transition: opacity 0.2s;
}
.banner-arrow:active {
  opacity: 0.7;
}
.banner-indicators {
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
  z-index: 10;
}
.banner-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transition: all 0.3s;
}
.banner-dot.active {
  background: #ffffff;
  width: 18px;
  border-radius: 3px;
}
/* 公告弹窗 */
.notice-popup {
  background: #252936 !important;
  width: 85%;
  max-width: 400px;
  border-radius: 12px !important;
}
.notice-popup__content {
  padding: 20px;
}
.notice-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  span {
    flex: 1;
    margin-left: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
  }
}
.notice-popup__body {
  color: #c0c6d8;
  font-size: 14px;
  line-height: 1.6;
  max-height: 50vh;
  overflow-y: auto;
}
</style>
